/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

const UnbreakableWifi = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--unbreakableWifi"
      {...props}
    >
      <path
        d="M8.24047 7.54163H7.82023C6.91907 7.54163 6.05992 7.81868 5.33152 8.34163L5.28794 8.37276L5.85136 9.13385L5.89494 9.10272C6.45837 8.69961 7.12451 8.48638 7.82179 8.48638H8.24202C8.95019 8.48638 9.62412 8.70584 10.1938 9.1214L10.2374 9.15253L10.807 8.39611L10.7634 8.36342C10.0288 7.8249 9.15875 7.54008 8.24358 7.54008L8.24047 7.54163Z"
        fill="white"
      />
      <path
        d="M8.24047 9.2179H7.82023C7.28171 9.2179 6.76654 9.38132 6.32918 9.69105L6.28405 9.72218L6.84591 10.4833L6.88949 10.4537C7.16342 10.2638 7.48405 10.1626 7.82023 10.1626H8.24047C8.58132 10.1626 8.90661 10.2669 9.18366 10.463L9.22724 10.4942L9.79689 9.73774L9.75175 9.70506C9.30973 9.38599 8.78833 9.2179 8.24047 9.2179Z"
        fill="white"
      />
      <path
        d="M8.03035 10.8926C7.53697 10.8926 7.13541 11.2926 7.13541 11.7844C7.13541 12.2763 7.53697 12.6763 8.03035 12.6763C8.52374 12.6763 8.92529 12.2763 8.92529 11.7844C8.92529 11.2926 8.52374 10.8926 8.03035 10.8926Z"
        fill="white"
      />
      <path
        d="M11.7642 5.98054C11.6833 5.92296 11.5992 5.86693 11.5121 5.81712V4.14086C11.5121 2.40545 10.1019 1 8.36031 1H7.72996C5.98988 1 4.57821 2.40545 4.57821 4.14086V4.37588H4.58132V5.81556C4.56265 5.8249 4.54552 5.8358 4.52685 5.84825C4.52218 5.84981 4.51751 5.85292 4.51284 5.85603C4.48482 5.87315 4.45837 5.89027 4.43191 5.90895C4.39611 5.9323 4.36031 5.95564 4.32451 5.9821C3.52451 6.55175 3 7.48405 3 8.5393V11.6802C3 13.414 4.41167 14.821 6.15175 14.821H9.93385C11.6755 14.821 13.0856 13.414 13.0856 11.6802V8.5393C13.0856 7.48405 12.5626 6.55175 11.7611 5.9821L11.7642 5.98054ZM5.83735 4.37588H5.83891V4.14086C5.83891 3.09961 6.6856 2.25603 7.72996 2.25603H8.36031C9.40467 2.25603 10.2514 3.09961 10.2514 4.14086V5.39689H6.15486C6.04747 5.39689 5.94163 5.40156 5.83735 5.41245V4.37588ZM11.828 11.6802C11.828 12.7214 10.9813 13.565 9.93696 13.565H6.15486C5.11051 13.565 4.26381 12.7214 4.26381 11.6802V8.5393C4.26381 7.49805 5.11051 6.65447 6.15486 6.65447H9.93696C10.9813 6.65447 11.828 7.49805 11.828 8.5393V11.6802Z"
        fill="white"
      />
      <path
        d="M4.58288 4.37588V5.81556C4.5642 5.8249 4.54708 5.8358 4.5284 5.84825C4.54553 5.83735 4.56109 5.82802 4.57821 5.81712L4.57821 4.37588H4.58132L4.58288 4.37588Z"
        fill="white"
      />
      <path
        d="M6.15486 5.39689C6.04747 5.39689 5.94163 5.40156 5.83735 5.41245V4.37588H5.83891L5.83891 5.39689L6.15486 5.39689Z"
        fill="white"
      />
    </svg>
  );
};

UnbreakableWifi.displayName = 'unbreakableWifi';

export default UnbreakableWifi;
